import isEqual from 'lodash.isequal'
import React, { memo } from 'react'

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m12.308 5.27-2.03 1.986a1.007 1.007 0 0 0 .689 1.718c.264.005.519-.095.71-.277l2.042-1.995a2.507 2.507 0 0 1 2.759-.582 2.506 2.506 0 0 1 1.37 1.382 2.52 2.52 0 0 1-.595 2.763l-1.98 2.037a1.007 1.007 0 0 0 .729 1.715 1 1 0 0 0 .707-.312l1.972-2.027a4.539 4.539 0 0 0 0-6.398 4.622 4.622 0 0 0-6.373-.01ZM12.285 15.3l-2.042 1.996a2.508 2.508 0 0 1-1.78.75 2.499 2.499 0 0 1-1.783-.742 2.514 2.514 0 0 1-.528-2.759c.13-.305.32-.582.557-.814l1.98-2.036a1.007 1.007 0 0 0-.733-1.699 1.001 1.001 0 0 0-.703.295L5.28 12.318a4.531 4.531 0 0 0 .037 6.354 4.506 4.506 0 0 0 6.336.051l2.03-1.982a1.007 1.007 0 0 0-.689-1.719 1 1 0 0 0-.71.278Z"
      fill="currentColor"
    />
    <path
      d="M8.6 15.39a1 1 0 0 0 1.417 0l5.348-5.362a1.006 1.006 0 0 0-1.092-1.647c-.122.053-.233.13-.326.225L8.6 13.968a1.005 1.005 0 0 0 0 1.423Z"
      fill="currentColor"
    />
  </svg>
)

const Link = memo(SvgComponent, isEqual)
export default Link
